import { Autocomplete, Chip, TextField, Box } from '@mui/material';

import { ITableFilterProps } from 'src/components/common/types/tableTypes';

export const TableFilter = <T,>({
	column,
	queryState,
	onQueryChange,
}: ITableFilterProps<T>) => {
	// TO DO: Simplify handleChange and selectedOptions logic
	const filterKey = column.filterParamKey || column.key.toString();
	const options = column.menuItems || [];

	const initialFilters = queryState.filters?.[filterKey] || [];
	const selectedOptions = options.filter((opt) =>
		Array.isArray(initialFilters)
			? initialFilters.includes(String(opt.value))
			: initialFilters === opt.value,
	);

	const handleChange = (
		_event: React.SyntheticEvent,
		value:
			| { label: string; value: string | number }
			| { label: string; value: string | number }[]
			| null,
	) => {
		const arr = Array.isArray(value) ? value : value ? [value] : [];

		const newFilters = arr.map((v) => String(v.value));

		onQueryChange({
			...queryState,
			page: 0,
			filters: { ...queryState.filters, [filterKey]: newFilters },
		});
	};

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<Autocomplete
				multiple={!!column.multiFilter}
				options={options}
				getOptionLabel={(opt) => opt.label}
				value={
					column.multiFilter
						? selectedOptions
						: (selectedOptions[0] ?? null)
				}
				onChange={handleChange}
				renderTags={(value, getTagProps) =>
					value.map((opt, i) => (
						<Chip
							{...getTagProps({ index: i })}
							key={opt.value}
							label={opt.label}
							size='small'
						/>
					))
				}
				renderInput={(params) => (
					<TextField {...params} size='small' label={column.label} />
				)}
				sx={{
					flex: 1,
					minWidth: 250,
					'& .MuiAutocomplete-inputRoot': {
						whiteSpace: 'normal',
						overflowWrap: 'break-word',
						wordBreak: 'break-word',
						hyphens: 'auto',
					},
				}}
				ListboxProps={{
					sx: {
						whiteSpace: 'normal',
						overflowWrap: 'break-word',
						wordBreak: 'break-word',
						maxHeight: '300px',
					},
				}}
			/>
		</Box>
	);
};
